import React from "react";
import NoResultsImg from "./img/noSearchResults.webp";
import { useSelector } from "react-redux";

export default function EmptySearchResults({ viewMore, viewMoreText }) {
  const lang = useSelector((state) => state.changeLang.language.cartType);

  return (
    <div className="text-center my-5">
      <img src={NoResultsImg} alt="no results" />
      <div className="mt-4 fw-bold fs-5">{lang.search[2]}</div>
      <div className="text-gray mt-1">{lang.search[3]}</div>
      <div className="text-gray">
        {lang.search[4]}{" "}
        <span
          className="text-primary cursor-pointer text-underline"
          onClick={viewMore}
        >
          {viewMoreText}

        </span>
      </div>
    </div>
  );
}
